module.exports = __webpack_public_path__ + "static/media/stewarts.3bd2ec63.png";